import React from 'react';

export interface IFloatingIndicatorProps {
  count: number;
}

const FloatingIndicator: React.FC<IFloatingIndicatorProps> = ({ count }) => {
  if (count === 0) return null;

  return (
    <span
      data-test="cartamount"
      className="bg-primary-main text-other-white lg:bg-other-white lg:text-primary-main absolute -top-1 -right-2 flex h-4.5 w-4.5 items-center justify-center rounded-full text-center text-xs"
    >
      {count}
    </span>
  );
};

export default FloatingIndicator;
